import React from 'react';
import {
    Button,
    FormControl,
    TextField
} from '@mui/material';
import { Form, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useAssignRuler, useRulersForCompany } from '../../hooks/useRulers';

function RulerTab(selectedCompProp){
    const userCompany = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const { data: allRulers = [] } = useRulersForCompany({
        companyId: userCompany?.id,
        enabled: Boolean(userCompany?.id),
    });
    const assignRuler = useAssignRuler();
    const [serialNumber, setSerialNumber] = React.useState();
    const [notes, setNotes] = React.useState('');

    let rulerData = {
        rulerSerialNumber: serialNumber,
        userId: userCompany.Id,
    };

    ///create ruler
    function submitRuler() {
        let numbArray = serialNumber.split('/')

        for (let i = 0; i < numbArray?.length; i++) {
            rulerData = {
                rulerSerialNumber: `EvanG3-${numbArray[i]}`,
                userId: userCompany.id
            }

            assignRuler.mutate(rulerData);
        }
    };

    function clearRulerData(){
        setNotes('');
        setSerialNumber();
    }

    return(
        <div>
            <h1>Ruler Management</h1>
            <Form style={{ width: "100%", margin: 'auto' }}>
                <Label>Enter all Rulers Purchased by <u>{userCompany.name}</u> Into the Botmark Management System.</Label>
                <br />
                <div style={{ display: 'flex', flexDirection:'column'}}>
                    <FormControl sx={{ m: 1 }} style={{ padding: 20 }}>
                        <Label style={{ padding: 10 }} htmlFor="outlined-adornment-amount"><b>Ruler Serial Number #</b></Label>
                        <Label style={{ padding: 10 }} htmlFor="outlined-adornment-amount">Please enter the last 6 digits of the Serial Number exactly as it appears on the EvanG3 Electronic Detailer. If you are entering more than one ruler please separate with a / .</Label>
                        <Label style={{ padding: 10 }} htmlFor="outlined-adornment-amount">Example: 000000 or 000000/000001</Label>
                        <TextField
                            style={{ width: '50%', alignSelf: 'center' }}
                            multiline rows={8}
                            id="outlined-adornment-amount"
                            onChange={(event) => setSerialNumber(event.target.value)}
                            />
                    </FormControl>
                </div>
                <Label>Warning: The system will not allow you to submit a ruler already in use.</Label>
                <br />
                <br />
                <Button color="primary" variant="contained" onClick={() => submitRuler()}>
                    Claim Ruler(s)
                </Button>
            </Form>
            <br/>
            {allRulers.map(item => (
                <div>
                    <span><b>Ruler Serial #:</b> {item?.rulerSerialNumber}</span>
                    { item?.warrantyDate &&
                        <span> / <b>Warranty Date:</b> {new Date(item?.warrantyDate).toLocaleDateString()}</span>
                    }
                </div>
            ))}
        </div>
    )
};

export default RulerTab;
